module.exports = __webpack_public_path__ + "img/9.0d15918a.png";